<template lang="html">
  <div :class="['cortina', show ? 'show' : '']"></div>
  <div
    :class="['modal-doc', show ? 'show' : '']"
    :style="{
      'background-image':
        'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(' +
        coverImg +
        ')',
    }"
  >
    <div class="content">
      <div class="controls">
        <i class="bi bi-x-lg" @click="closeModal"></i>
      </div>
      <div class="header">
        <h4 class="subtitle">{{ title }}</h4>
      </div>
      <div class="contenido">
        <div class="slider">
          <ListCardModalList :data="data"/>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
import ListCardModalList from "../ModalList/ListCardModalList.vue";

export default {
  emits: ["updateShow"],
  components: {
    ListCardModalList,
  },
  props: {
    title: String,

    show: {
      type: Boolean,
      default: false,
    },
    coverImg: String,
    eventSuccess: {
      type: Function,
    },
    action: String,
    data:Array,
  },
  methods: {
    closeModal() {
      let nav = document.getElementById("navbarCeed");
      nav.classList.remove("display-none");
      this.$emit("updateShow", false);
      localStorage.setItem("status", false);
    },
  },
};
</script>
<style lang="css" scoped>
.slider {
  width: 100%;
}
.controls i {
  cursor: pointer;
}

@media (max-width: 375px) {
  .modal-doc {
    padding: 0 !important;
  }
  .controls i {
    margin: 10px 20px 0 0;
  }
}

@media (min-width: 425px) {
  .modal-doc {
    padding: 20px !important;
  }
}


.cortina {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: none;
}
.cortina.show {
  display: block;
  z-index: 5 !important;
}
.modal-doc {
  width: 95%;
  height: 80%;
  background: #ffffff;
  background-size: cover;
  border-radius: 8px;
  padding: 56px;
  box-shadow: 2px 2px 20px #07193117;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  display: none;
  z-index: 6 !important;
  max-width: 1440px;
}
.modal-doc.show {
  display: block;
}
.modal-doc .content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
}
.contenido {
  width: 100%;
}
.modal-doc .content .icon {
  margin-bottom: 22px;
}
.modal-doc .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 37px;
  color: #013652;
  margin-bottom: 12px;
}
.modal-doc .content .description {
  max-width: 410px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #696f72;
  text-align: center;
  margin-bottom: 48px;
}
.modal-doc .content .buttons {
  display: flex;
  column-gap: 10px;
}
.modal-doc .watermark {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
.subtitle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 35px;
  line-height: 41px;
  color: #013652;
  position: relative;
  display: inline;
}
.subtitle::after {
  content: "";
  position: absolute;
  bottom: -7px;
  left: 15%;
  width: 70%;
  height: 2px;
  background: #013652;
}
.slider {
  margin-bottom: 40px;
}
.header {
  margin-bottom: 50px;
}
.controls {
  width: 100%;
  font-size: 30px;
  float: right;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .subtitle {
    font-size: 24px;
    line-height: 29px;
  }
}

@media (max-width: 1650px) {
  .modal-doc {
    max-width: 1110px;
  }
}

@media (max-width: 1130px) {
  .modal-doc {
    max-width: 763px;
  }
}

@media (max-width: 776px) {
  .modal-doc {
    max-width: 430px;
  }
}
</style>
